import {
  BreakpointAction,
  ChoiceFunction,
  ConsideringPurchaseOption,
  EligibleAppleWatchBreakpointOption,
  NightSleepBreakpointOption,
  PurchaseNewWatchOption,
  QuizDataInput,
  SleepWithTrackerOption,
  WhichWearableBreakpointOption,
} from '@naturalcycles/shared'
import { Page } from '@src/app/shared/typings/enum/pages.js'
import { allQuizSections } from '../quiz.js'

const firstPathTransformFunction: ChoiceFunction<Page, QuizDataInput> = (flow, data) => {
  const isAppleWatchEligible = data?.eligibleAppleWatch === EligibleAppleWatchBreakpointOption.yes
  const isWillingToPurchaseAW =
    data?.purchaseNewWatch === PurchaseNewWatchOption.yes ||
    data?.consideringPurchase === ConsideringPurchaseOption.yesAppleWatch
  const sleepsThroughTheNight =
    data?.nightSleep === NightSleepBreakpointOption.sleepsThroughTheNight
  const appleWatch = data?.whichWearable?.includes(WhichWearableBreakpointOption.appleWatch)
  const ouraUser = data?.whichWearable?.includes(WhichWearableBreakpointOption.ouraRing)

  flow[allQuizSections.routine] = [
    Page.naturalMethod,
    Page.yourMeasuringDevice,
    Page.whichWearable,
    Page.equallyEffectiveInfo,
    ...(appleWatch
      ? [Page.eligibleAppleWatch, Page.equallyEffectiveInfo]
      : [Page.equallyEffectiveInfo]),
    Page.nightSleep,
    ...(sleepsThroughTheNight
      ? [Page.sleepWearable]
      : [Page.troubleGettingBackToSleep, Page.sleepWearable]),
    // the !ouraUser check is if they navigate back and change hardware selection
    // if Oura is added we need to make sure wearYourWatchToBed is not added
    ...((isAppleWatchEligible || isWillingToPurchaseAW) && !ouraUser
      ? [Page.wearYourWatchToBed, Page.sleepConsistency]
      : [Page.sleepConsistency]),
    Page.spendingDaysInfo,
    Page.healthGoals,
    Page.feelingStressed,
    Page.biggestStressor,
    Page.favoriteWayToUnwind,
    Page.deviceTrait,
    Page.resultOverview,
  ]
  return flow
}

const secondPathTransformFunction: ChoiceFunction<Page, QuizDataInput> = (flow, data) => {
  const sleepsThroughTheNight =
    data?.nightSleep === NightSleepBreakpointOption.sleepsThroughTheNight
  const appleWatch = data?.whichWearable?.includes(WhichWearableBreakpointOption.appleWatch)

  flow[allQuizSections.routine] = [
    Page.naturalMethod,
    Page.yourMeasuringDevice,
    Page.whichWearable,
    Page.equallyEffectiveInfo,
    ...(appleWatch
      ? [Page.eligibleAppleWatch, Page.equallyEffectiveInfo]
      : [Page.equallyEffectiveInfo]),
    Page.nightSleep,
    ...(sleepsThroughTheNight
      ? [Page.sleepWearable]
      : [Page.troubleGettingBackToSleep, Page.sleepWearable]),
    Page.sleepConsistency,
    Page.spendingDaysInfo,
    Page.healthGoals,
    Page.feelingStressed,
    Page.biggestStressor,
    Page.favoriteWayToUnwind,
    Page.deviceTrait,
    Page.resultOverview,
  ]
  return flow
}

export const sleepWearable: BreakpointAction<SleepWithTrackerOption, Page, QuizDataInput> = {
  [SleepWithTrackerOption.yesWithRing]: firstPathTransformFunction,
  [SleepWithTrackerOption.yesWithWatch]: secondPathTransformFunction,
  [SleepWithTrackerOption.yesWithBoth]: secondPathTransformFunction,
  [SleepWithTrackerOption.neither]: firstPathTransformFunction,
}
